import {ImageViewerDataVo} from '../../common/shared/api/gateway/viewer/ImageViewerDataVo.interface';
import {TalkViewerDataVo} from '../../common/shared/api/gateway/viewer/TalkViewerDataVo.interface';
import {TextViewerDataVo} from '../../common/shared/api/gateway/viewer/TextViewerDataVo.interface';
import {VodViewerDataVo} from '../../common/shared/api/gateway/viewer/VodViewerDataVo.interface';
import {createImageViewerData} from './ImageViewerData';
import {createTalkViewerData} from './TalkViewerData';
import {createTextViewerData} from './TextViewerData';
import {createVodViewerData} from './VodViewerData';

export function createViewerData(
  viewer_data:
    | TextViewerDataVo
    | TalkViewerDataVo
    | ImageViewerDataVo
    | VodViewerDataVo
) {
  if ('contents_list' in viewer_data) {
    return createTextViewerData(viewer_data);
  } else if ('talk_download_data' in viewer_data) {
    return createTalkViewerData(viewer_data);
  } else if ('download_data' in viewer_data) {
    return createImageViewerData(viewer_data);
  } else if ('vod_download_data' in viewer_data) {
    return createVodViewerData(viewer_data);
  }
}
